import type {PropsWithChildren, Ref} from 'react'

import styles from './AhpTaskChatInputActionBar.module.css'

export interface AhpTaskChatInputActionBarProps extends PropsWithChildren {
  ref?: Ref<HTMLDivElement>
}

export function AhpTaskChatInputActionBar({children, ref}: AhpTaskChatInputActionBarProps) {
  return (
    <div ref={ref} className={styles.ActionBar}>
      {children}
    </div>
  )
}

AhpTaskChatInputActionBar.displayName = 'AhpTaskChatInputActionBar'
